import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface Signature {
  Element: HTMLSpanElement;
  Args: { confirmation: string };
}

const FormConfirmationComponent: TemplateOnlyComponent<Signature> = <template>
  <span class='text-teal'>{{@confirmation}}</span>
</template>;

export default FormConfirmationComponent;
